import React from "react";
import PropTypes from "prop-types";
import {css} from "glamor";
import SmartDialog from "../SmartDialog";
import _ from "lodash";

export class ActionSelectDialog extends React.Component {

    static propTypes = {
        title: PropTypes.string
    };

    static defaultProps = {
        title: "Select an action"
    };

    static itemStyle = css({
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "rgba(0,0,0,0.98)",
            color: "rgba(255,255,255)"
        }
    });

    constructor(props) {
        super(props);
        this.state = {
            actions: []
        };
    }

    show(actions) {

        this.setState({
            actions
        }, () => {
            this._dlg.show();
        });
    }

    render() {

        const {actions} = this.state;
        return <SmartDialog title={this.props.title} ref={r => this._dlg = r}>
            <div className="p-1">
                {actions.map((action, k) => (!action.disabled &&
                    <div key={k} className={`p-2 ${ActionSelectDialog.itemStyle}`} onClick={() => {

                        if (_.isFunction(action.onClick))
                            action.onClick();

                        this._dlg.hide();
                    }}>{action.icon && <i className={`${action.icon}`}/>} {_.isString(action.label) ?
                        <span className="ml-2">{action.label}</span> : action.label}
                    </div>))}
            </div>
        </SmartDialog>;

    }
}


// WEBPACK FOOTER //
// ./src/components/ActionSelectDialog/ActionSelectDialog.js